import {Stack, useTheme} from "@mui/material";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import {useHistory} from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {useContext, useEffect, useState} from "react";
import ConfigContext from "../context/ConfigContext";
import CircleButton from "../components/CircleButton";
import {thousandSeparator} from "../utils/Utils";
import useCallDataApi from "../hooks/data";
import Loading from "../components/Loading";
import ReservationContext from "../context/ReservationContext";
import NoItems from "../components/NoItems";


const Colleague = ({colleague, price, advance=null}) => {
    const theme = useTheme()
    const {baseUrl} = useContext(ConfigContext)

    return <div style={{display: 'flex', gap: '20px'}}>
        <Avatar src={colleague?.profile_picture ? baseUrl + colleague.profile_picture : ''} sx={{width: 70, height: 70, alignSelf: 'center', background: theme.palette.primary[200]}}/>
        <div className="text-container">
            <Typography align="left" variant="subtitle1">{colleague?.last_name} {colleague?.first_name}</Typography>
            <Typography align="left" variant="body2">{colleague?.title}</Typography>
            <Stack direction='row' spacing={2}>
                <Typography align="left" variant="body1">{thousandSeparator(price)} Ft</Typography>
                {advance && <Typography color={theme.palette.grey.A700} align="left" variant="body2">{advance} % előleg fizetendő</Typography>}
            </Stack>
        </div>
    </div>
}


const SelectPrice = () => {
    const {getData: fetchPrices} = useCallDataApi('sp-prices')
    const {selected, next, isOnlinePaymentAuthorized} = useContext(ReservationContext)
    const [loading, setLoading] = useState(true)
    const [prices, setPrices] = useState([])
    const history = useHistory()

    useEffect(() => {
        if (selected?.service) fetchPrices(`get_for_service/?service=${selected?.service?.id}`)
            .then(p => setPrices(p))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected?.service])

    const proceed = (p) => {
        next({...selected, price: p})
        history.push({
            pathname: '/book',
            search: `?c=${selected?.category?.id}&s=${selected?.service?.id}&p=${p.id}`
        })
    }

    return <div className="data-container">
        <Stack spacing={{xs: 2}}>
            {prices.map((p, i) =>
                <Box className="data-select" key={`data_${i}`}>
                    <Stack direction="row" spacing={{xs: 2}} sx={{justifyContent: 'space-between'}}>
                        <Colleague colleague={p?.colleague} price={p?.price} advance={(selected?.service?.is_pay_advance && isOnlinePaymentAuthorized) ? selected?.service?.advance_amount : null}/>
                        <CircleButton icon={<NavigateNextIcon/>} onClick={() => proceed(p)}/>
                    </Stack>
                </Box>)}
            {prices.length === 0 && <NoItems title='Nincs beállítva elérhető kolléga!' description='Az oldal kezelői még nem állítottak be árat és kollégát ehhez a szolgáltatáshoz.'/>}
        </Stack>

        <Loading isLoading={loading}/>
    </div>
}

export default SelectPrice